import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { showSuccess, showError } from '../../../../../../Helper';
import {
  DeleteDeveloperContactDocumentAPI,
  DeleteScopeDocument,
  DeleteVendorDocument,
} from '../../../../../../Services';
import { DialogComponent, Spinner } from '../../../../../../Components';

const parentTranslationPath = 'UnitsView';

export const DeleteDocumentDialog = ({
  open,
  close,
  onSave,
  activeItem,
  isDeveloperContact,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [isLoading, setIsLoading] = useState(false);

  const deleteHandler = async () => {
    setIsLoading(true);
    let res = null;
    if (isDeveloperContact) {
      res = await DeleteDeveloperContactDocumentAPI(
        activeItem?.developerContactDocumentId
      );
      setIsLoading(false);
    } else if (activeItem?.scopeDocumentId) {
      res = await DeleteScopeDocument(activeItem?.scopeDocumentId);

      if (!(res && res.status && res.status !== 200)) {
        showSuccess(t(`delete-document-successfully`));
        onSave();
      } else showError(t(`delete-document-failed`));
      setIsLoading(false);
    } else {
      try {
        setIsLoading(true);
        await DeleteVendorDocument(activeItem?.vendorDocumentId);
        showSuccess(t(`delete-document-successfully`));
        onSave();
      } catch (error) {
        showError(t(`delete-document-failed`));
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <DialogComponent
      titleText={t(`delete-document`)}
      saveText={t('confirm')}
      saveType='button'
      maxWidth='sm'
      dialogContent={
        <div className='d-flex-column-center'>
          <Spinner isActive={isLoading} />
          <span className='mdi mdi-close-octagon c-danger mdi-48px' />
          <div className='w-100' style={{ display: 'block' }}>
            {' '}
            <span>{`${t('Are-you-sure-you-want-to-Delete')}`} :</span>{' '}
            <div style={{ fontWeight: 600, width: '130px' }}>
              <p
                style={{
                  fontWeight: 600,
                  width: '30rem',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {' '}
                {`${
                 
                  activeItem?.fileName ||
                  activeItem?.documentLink
                  || 
                  activeItem?.scopeDocumentId
                }`}{' '}
              </p>{' '}
            </div>
          </div>
        </div>
      }
      saveClasses='btns theme-solid bg-danger w-100 mx-2 mb-2'
      isOpen={open}
      onSaveClicked={deleteHandler}
      onCloseClicked={close}
      onCancelClicked={close}
    />
  );
};
DeleteDocumentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  activeItem: PropTypes.instanceOf(Object).isRequired,
};
